import { useEffect } from "react";
import { PREINSCRIPTION_URL } from "../data/site";

export default function PreInscription() {
  useEffect(() => {
    window.location.replace(PREINSCRIPTION_URL);
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-24 text-center text-ink-soft">
      <p>Redirection vers le formulaire de pré-inscription…</p>
      <p className="mt-4">
        Si rien ne se passe,{" "}
        <a
          href={PREINSCRIPTION_URL}
          className="text-terra hover:underline"
        >
          cliquez ici
        </a>
        .
      </p>
    </div>
  );
}
